module.exports = __webpack_public_path__ + "img/Flag_of_Spain.caa6452f.svg";